import * as React from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap'

export default function VehicleView({
    vehicle
}) {
    if (!vehicle) return null;
    return (
        <Card className="card-box mb-3">
            <CardHeader>
                <h4 className="font-size-lg mb-0 py-0 font-weight-bold">
                    Dati del Veicolo
                </h4>
            </CardHeader>
            <CardBody className="px-4 pt-3">

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Targa</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {vehicle.plate}
                    </div>
                </div>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Modello</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {vehicle.attributes.preparation}
                    </div>
                </div>

            </CardBody>
        </Card>
    );
}
